import { ReactNode } from "react";
import styles from "./dialog.module.scss";
import * as DialogRU from "@radix-ui/react-dialog";
import classNames from "classnames";

/**
 * @deprecated TODO: refactor
 */
export function Dialog(props: Props) {
  const {
    contentNode,
    triggerNode,
    closeNode,
    rootProps,
    contentProps,
    overlayProps,
    contentClassName,
    overlayClassName,
    closeProps,
  } = props;

  const Content = ({ children }: { children?: ReactNode }) => (
    <DialogRU.Portal>
      <DialogRU.Overlay
        {...overlayProps}
        className={classNames(styles["dialogOverlay"], overlayClassName)}
      />
      <DialogRU.Content
        {...contentProps}
        className={classNames(
          styles["dialogContentContainer"],
          contentClassName,
        )}
      >
        {children}
      </DialogRU.Content>
    </DialogRU.Portal>
  );

  return (
    <DialogRU.Root {...rootProps}>
      <DialogRU.Trigger asChild>{triggerNode}</DialogRU.Trigger>
      <Content>
        <DialogRU.Close {...closeProps} asChild>
          {closeNode}
        </DialogRU.Close>
        {contentNode}
      </Content>
    </DialogRU.Root>
  );
}

interface Props {
  triggerNode?: ReactNode;
  contentNode?: ReactNode;
  closeNode?: ReactNode;
  rootProps?: DialogRU.DialogProps;
  contentProps?: DialogRU.DialogContentProps;
  overlayProps?: DialogRU.DialogOverlayProps;
  closeProps?: DialogRU.DialogCloseProps;
  contentClassName?: string;
  overlayClassName?: string;
}
